import { render, staticRenderFns } from "./PartnersEditPartnerHeader.vue?vue&type=template&id=4bdf78e6&"
import script from "./PartnersEditPartnerHeader.vue?vue&type=script&lang=js&"
export * from "./PartnersEditPartnerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports